export const CORE_JS_BUNDLE_URL = 'https://static.parastorage.com/unpkg/core-js-bundle@3.2.1/minified.js'
export const REACT_PROD_URL = 'https://static.parastorage.com/unpkg/react@16.13.1/umd/react.production.min.js'
export const REACT_DEV_URL = 'https://static.parastorage.com/unpkg/react@16.13.1/umd/react.development.js'
export const REACT_DOM_PROD_URL =
	'https://static.parastorage.com/unpkg/react-dom@16.13.1/umd/react-dom.production.min.js'
export const REACT_DOM_DEV_URL = 'https://static.parastorage.com/unpkg/react-dom@16.13.1/umd/react-dom.development.js'
